import { SOLD_VEHICLE_TAG, VehicleStatuses } from 'common/constants'
import { colorDanger, colorSold, colorWinning } from 'common/theme'
import { StyledTag } from 'modules/BuyerActivity/VehicleAuction.styled'
import { useContext } from 'react'
import { useGlobalStore } from 'store/useGlobalStore'
import styled from 'styled-components'
import { VehicleContext } from './VehicleContext'
import classNames from 'classnames'
import { useBiddingSidePanel } from 'store/useBiddingSidePanelStore'

export const StyledVehicleTags = styled.div`
  ${StyledTag} {
    width: 10rem;
  }
`

interface IProps {
  direction?: 'left' | 'right'
  className?: string
}

export const VehicleTags = ({ className, direction = 'left' }: IProps) => {
  const {
    vehicleData: { vehicle: vehicleInfo, auctionInfo }
  } = useContext(VehicleContext)
  const getLocalText = useGlobalStore((state) => state.getLocalText)
  const isPurchaseExclusiveVehicle = useBiddingSidePanel((state) => state.isPurchaseExclusiveVehicle)

  // Check if this specific vehicle has been purchased
  const isThisVehiclePurchased = vehicleInfo?.InstanceID ? isPurchaseExclusiveVehicle(vehicleInfo.InstanceID) : false

  return (
    <StyledVehicleTags className={className}>
      {(vehicleInfo.StatusID === VehicleStatuses.SoldNotFunded || isThisVehiclePurchased) && (
        <div>
          <StyledTag className={classNames({ right: direction === 'right' })} color={colorSold}>
            <span>{SOLD_VEHICLE_TAG}</span>
          </StyledTag>
        </div>
      )}
      {vehicleInfo.StatusID === VehicleStatuses.OnSale && auctionInfo && auctionInfo.HasPreviousBid ? (
        <div>
          <StyledTag
            className={classNames({ right: direction === 'right' })}
            color={auctionInfo.IsHighestBidder ? colorWinning : colorDanger}
          >
            <span>
              {auctionInfo.IsHighestBidder ? getLocalText('WINNING', 'winning') : getLocalText('OUTBID', 'outbid')}
            </span>
          </StyledTag>
        </div>
      ) : (
        <StyledTag color="transparent" className={classNames({ right: direction === 'right' })} />
      )}
      {vehicleInfo.StatusID !== VehicleStatuses.SoldNotFunded && Boolean(vehicleInfo.WatchListID) && (
        <div>
          <StyledTag className={classNames({ right: direction === 'right' })}>
            <span>watching</span>
          </StyledTag>
        </div>
      )}
    </StyledVehicleTags>
  )
}
